import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAccountOpt} from "./Accounts.tsx";
import {useEffect} from "react";
import {EventerConsoleNavigation} from "../../../EventerConsoleNavigation.tsx";

export default function AccountGuard() {

    const account = useAccountOpt()

    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {

        if (account === undefined) {
            // loading ...
            return
        }

        if (account === null) {
            // No account found
            console.log("No account found ==> redirect to accounts page")
            EventerConsoleNavigation.accounts.navigate(navigate, location, true)
            return
        }
    }, [account, location, navigate])

    if (!account) {
        // handled by the guard
        return null
    }

    return <Outlet/>
}